function readCookie(namex) {
  var nameEQ = namex + "=";
  var ca = decodeURIComponent(document.cookie).split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) {
        let value = JSON.parse(c.substring(nameEQ.length,c.length));
        value = JSON.parse(value);
        return value;
      }
  }
  return null;
}

export default readCookie;
